<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-6">
    <div class="max-w-7xl mx-auto pb-12">
      <router-view />
    </div>
  </div>
</template>
